import { render, staticRenderFns } from "./AdminOption.vue?vue&type=template&id=2d16c8e5&scoped=true&"
import script from "./AdminOption.vue?vue&type=script&lang=js&"
export * from "./AdminOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d16c8e5",
  null
  
)

export default component.exports